import { FilterMatchMode } from "primereact/api";

export class Transaccion {
    model = {
        id: {
            value: null,
            export: false,
            header: 'Código',
            table: false,
            showFilterMatchModes: false,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },
        nombres: {
            value: '',
            export: false,
            table: true,
            header: 'Nombres',
            max: 400, min: 4,
            minLength: 'Mínimo 4 caracteres',
            sort: true,
            filter: true,
            filterField: 'nombres',
            matchMode: FilterMatchMode.CONTAINS,
            frozen: true,
            headerStyle: { minWidth: '175px' },
        },
        empresa: {
            value: [],
            export: false,
            table: true,
            header: 'Empresa',
            sort: true,
            filter: true,
            filterField: 'empresa',
            headerStyle: { minWidth: '200px' },
        },
        tipo_identificacion: {
            value: '',
            export: false,
            table: false,
            header: 'Tipo de Identificación',
            headerStyle: { minWidth: '200px' }
        },
        identificacion: {
            value: '',
            export: false,
            table: true,
            header: 'Identificación',
            required: 'Identificación es requerido',
            max: 20, min: 4,
            minLength: 'Mínimo 4 caracteres',
            filter: true,
            filterField: 'identificacion',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { minWidth: '175px' }
        },
        codigo: {
            value: '',
            export: false,
            table: true,
            header: 'Código Único',
            required: 'El código es requerido',
            max: 50, min: 3,
            minLength: 'Mínimo 3 caracteres',
            filter: true,
            filterField: 'codigo',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { minWidth: '150px' }
        },
        valor: {
            value: null,
            export: false,
            table: true,
            header: 'Valor',
            required: 'Valor es requerido',
            isNumeric: true,
            isCurrency: true,
            filter: true,
            matchMode: FilterMatchMode.EQUALS,
            filterField: 'valor',
            headerStyle: { minWidth: '150px' }
        },
        fecha: {
            value: null,
            table: true,
            export: false,
            header: 'Fecha',
            required: 'Fecha es requerida',
            filter: true, sort: true, isDate: true,
            headerStyle: { minWidth: '200px' },
            body: (rowData) => {
                if (!rowData.fecha) return null;
                return new Date(rowData.fecha + 'T00:00:00').toLocaleDateString(); // Media noche hora local
            }
        },
        tipo_instrumento: {
            value: null,
            export: false,
            table: true,
            header: 'Instrumento de pago',
            required: 'Instrumento de pago es requerido',
            sort: true,
            filter: true,
            filterField: 'tipo_instrumento',
            matchMode: FilterMatchMode.IN,
            isMultiselect: true,
            catalogKey: 'instrumento_pago',
            headerStyle: { minWidth: '200px' }
        },
        detalle: {
            value: '',
            export: false,
            table: true,
            header: 'Detalle transacción',
            required: 'Detalle es requerido',
            max: 500, min: 5,
            minLength: 'Mínimo 5 caracteres',
            headerStyle: { minWidth: '250px' }
        },
        pais_id: {
            value: '',
            export: false,
            table: false,
            header: 'País',
            required: 'El país es requerido',
            headerStyle: { minWidth: '200px' }
        },
        provincia_id: {
            value: '',
            export: false,
            table: false,
            header: 'Provincia',
            required: 'La provincia es requerida',
            headerStyle: { minWidth: '200px' }
        },
        ciudad_id: {
            value: '',
            export: false,
            table: false,
            header: 'Ciudad',
            required: 'La ciudad es requerida',
            headerStyle: { minWidth: '200px' }
        },
        ciudad: {
            value: '',
            export: false,
            table: false,
            header: 'Ciudad',
            required: 'La ciudad es requerida',
            max: 250, min: 4,
            minLength: 'Mínimo 4 caracteres',
            headerStyle: { minWidth: '200px' }
        },
        tipo_producto: {
            value: null,
            header: 'Tipo de producto',
            required: 'Tipo de producto es requerido',
            table: false,
        },
    };

    template = (body, info, columnasExtra) => {
        const headers = [
            { text: 'N°', style: 'th' },
            { text: 'Cliente', style: 'th' },
            { text: 'Empresa', style: 'th' },
            { text: 'Identificación', style: 'th' },
            { text: 'Tipo Transacción', style: 'th' },
            { text: 'Código Único', style: 'th' },
            { text: 'Valor', style: 'th' },
        ];

        if (columnasExtra.incluirValor1) headers.push({ text: 'Liquidación CV', style: 'th' });
        if (columnasExtra.incluirValor2) headers.push({ text: 'Liquidación BV', style: 'th' });
        if (columnasExtra.incluirTipoProducto) headers.push({ text: 'Producto', style: 'th' });

        headers.push(
            { text: 'Detalle', style: 'th' },
            { text: 'País', style: 'th' },
            { text: 'Provincia', style: 'th' },
            { text: 'Ciudad', style: 'th' },
            { text: 'Fecha Transacción', style: 'th' },
            { text: 'Fecha Registro', style: 'th' }
        );

        return {
            pageOrientation: 'landscape',
            pageSize: 'A3',
            pageMargins: [40, 100, 40, 40],
            header: {
                margin: [40, 20, 40, 20],
                columns: [
                    info.logo
                        ? { image: info.logo, width: 80, alignment: 'left' }
                        : { text: '', width: 80 },
                    {
                        stack: [
                            { text: 'Listado de Transacciones', style: 'header', alignment: 'center', margin: [0, 0, 0, 5] },
                            { text: info.razon_social || '', alignment: 'center', bold: true, fontSize: 10, margin: [0, 0, 0, 2] },
                            {
                                text: [
                                    { text: 'Fecha de generación del reporte: ', bold: true },
                                    { text: info.fecha_generacion || '' }
                                ],
                                alignment: 'center', fontSize: 9
                            },
                            {
                                text: [
                                    { text: 'Periodo: ', bold: true },
                                    { text: 'Desde: ' + (info.fecha_inicio) + ' Hasta: ' + (info.fecha_fin) }
                                ],
                                alignment: 'center', fontSize: 9
                            }
                        ],
                        width: '*'
                    },
                    { text: '', width: 80 }
                ]
            },
            footer: (currentPage, pageCount) => ({
                columns: [
                    { text: `Periodo: Desde el ${info.fecha_inicio} hasta el ${info.fecha_fin}`, alignment: 'left', fontSize: 9, width: '33%' },
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'center', fontSize: 9, width: '34%' },
                    { text: `Total de transacciones: ${info.total_transacciones || ''}`, alignment: 'right', fontSize: 9, width: '33%' }
                ],
                margin: [40, 10, 40, 0]
            }),
            content: [
                {
                    table: {
                        headerRows: 1,
                        widths: [25, 80, 110, ...Array(headers.length - 3).fill('*')],
                        body: [headers, ...body]
                    },
                    layout: {
                        fillColor: function (rowIndex) {
                            return rowIndex === 0 ? '#eeeeee' : null;
                        },
                        hLineColor: '#ccc',
                        vLineColor: '#ccc',
                        paddingLeft: () => 4,
                        paddingRight: () => 4
                    }
                }
            ],
            styles: {
                header: { fontSize: 16, bold: true },
                th: { bold: true, fontSize: 8, color: '#000000' }
            },
            defaultStyle: {
                alignment: 'center',
                fontSize: 7
            }
        };
    };
}
